import defaultReducers from '@src/models/defaultReducers'
import { KustomerConversationsQuery } from '../graphql/kustomerConversations.generated'
import { KustomerConversationMessagesQuery } from '../graphql/kustomerConversationMessages.generated'
import { KustomerArticlesQuery } from '../graphql/kustomerArticles.generated'
import { KustomerArticleVersionPreviewQuery } from '../graphql/kustomerArticleVersionPreview.generated'
import { SupportHubStoreState } from './supportHub.types'

export const reducers = {
  ...defaultReducers,

  updateArticles: (
    state: SupportHubStoreState,
    {
      payload,
    }: {
      payload: {
        kustomerArticles: KustomerArticlesQuery['kustomerArticles']
      }
    },
  ) => {
    return {
      ...state,
      articles: payload.kustomerArticles && payload.kustomerArticles.articles,
    }
  },

  updateArticleVersionPreview: (
    state: SupportHubStoreState,
    {
      payload,
    }: {
      payload: {
        kustomerArticleVersionPreview: KustomerArticleVersionPreviewQuery['kustomerArticleVersionPreview']
      }
    },
  ) => {
    return {
      ...state,
      articleVersionPreview: payload.kustomerArticleVersionPreview,
    }
  },

  updateConversations: (
    state: SupportHubStoreState,
    {
      payload,
    }: {
      payload: {
        kustomerConversations: KustomerConversationsQuery['kustomerConversations']
      }
    },
  ) => {
    return {
      ...state,
      conversations: payload.kustomerConversations && payload.kustomerConversations.conversations,
    }
  },

  updateConversationMessages: (
    state: SupportHubStoreState,
    {
      payload,
    }: {
      payload: {
        kustomerConversationMessages: KustomerConversationMessagesQuery['kustomerConversationMessages']
      }
    },
  ) => {
    return {
      ...state,
      messages: payload.kustomerConversationMessages.messages,
    }
  },
}
